export default function Player() {
  return (
    <div className="min-h-screen p-8">
      <h1 className="text-4xl font-bold gradient-text">Video Player</h1>
      <p className="mt-4 text-star-white/70">Cinematic player coming soon...</p>
    </div>
  )
}
